import React, { useEffect, useState } from "react";
import { ROUTES } from "../../constants/clientRoutes";
import { Props } from "../../types/props";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SetShowCancelModal } from "../../actions/bankAccounts";

import FlowScreen from "../../components/Layouts/FlowScreen";
import CountryCurrencySelection from "./CountryCurrencySelection";
import ActionRow from "../../components/Layouts/ActionRow";
import Action from "../../components/Common/Action";
import ApiErrorModal from "../../components/Common/Modals/ApiErrorModal";
import AccountDetails from "./AccountDetails";
import PageBlock from "../../components/Layouts/PageBlock";
import ReviewAccountDetails from "./ReviewAccountDetails";
import CommunicationPreferences from "./CommunicationPreferences";
import Confirmed from "./Confirmed";
import BankAccountFormWrapper from "./BankAccountFormWrapper";

const BankAccountWizard = (props: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [page, setPage] = useState("");
  const [showBackButton, setShowBackButton] = useState(true);
  const [forwardButton, setForwardButton] = useState<{
    text: string;
    clickFunc: () => void;
    disabled: boolean;
    loading?: boolean;
  }>({
    text: "",
    clickFunc: () => { },
    disabled: false,
    loading: false
  });

  useEffect(() => {
    setPage(props?.location?.pathname || "");
    // Hide back button on confirmed page
    if (props?.location?.pathname === ROUTES.BANKS_ACCOUNTS.CONFIRMED) {
      setShowBackButton(false);
    }
  }, [props?.location?.pathname]);

  const handleBackButtonClick = () => {
    if (page === ROUTES.BANKS_ACCOUNTS.BENEFICIARY_DETAILS) {
      dispatch(SetShowCancelModal(true));
    } else if (page === ROUTES.BANKS_ACCOUNTS.COUNTRY) {
      history.push(ROUTES.BANKS_ACCOUNTS.INDEX);
    } else {
      history.goBack();
    }
  }

  const childProps = { setTitle, setSubTitle, setForwardButton };

  return (
    <FlowScreen
      flowTitle={title}
      className="v3 position-relative"
      showBackButton={showBackButton}
      customBackButtonFunc={handleBackButtonClick}
    >
      {page !== ROUTES.BANKS_ACCOUNTS.CONFIRMED &&
        <PageBlock>

          <p className="large">{subTitle}</p>

          {/* Country Currency Selection */}
          {page === ROUTES.BANKS_ACCOUNTS.COUNTRY && <CountryCurrencySelection {...childProps} />}

          {/*  Account Details */}
          {page === ROUTES.BANKS_ACCOUNTS.ACCOUNT_DETAILS && <AccountDetails {...childProps} />}

          {/*  Beneficiary details form */}
          {page === ROUTES.BANKS_ACCOUNTS.BENEFICIARY_DETAILS && <BankAccountFormWrapper {...childProps} />}

          {/*  Bank details form */}
          {page === ROUTES.BANKS_ACCOUNTS.BANK_DETAILS && <BankAccountFormWrapper {...childProps} />}

          {/*  Review Account Details */}
          {page === ROUTES.BANKS_ACCOUNTS.REVIEW_ACCOUNT_DETAILS && <ReviewAccountDetails {...childProps} />}

          {/*  Comminication Preferences */}
          {page === ROUTES.BANKS_ACCOUNTS.COMMUNICATION_PREFERENCES && <CommunicationPreferences {...childProps} />}

          <ActionRow>
            <ActionRow.Backward>
              <Action
                title={forwardButton.text}
                displayType={ACTION_DISPLAY_TYPES.PRIMARY}
                onClick={forwardButton.clickFunc}
                disabled={forwardButton.disabled}
                loading={forwardButton.loading}
                type="submit"
              />
            </ActionRow.Backward>
          </ActionRow>
        </PageBlock>
      }

      {/*  Confirmed */}
      {page === ROUTES.BANKS_ACCOUNTS.CONFIRMED && <Confirmed {...childProps} />}

      <ApiErrorModal />
    </FlowScreen>
  );
}

export default BankAccountWizard;